import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { Project, ResponsePayload } from "@/types";
import { fetchProject } from "./thunk";

export interface ProjectState {
  project: Partial<Project>;
  status: "idle" | "fetching" | "saving";
  error: string | null;
}

const initialState: ProjectState = {
  project: {},
  error: null,
  status: "idle"
};

export const projectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[projectSlice.name]
        };
      })
      .addCase(fetchProject.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchProject.fulfilled, (state, action) => {
        state.status = "idle";
        state.project = action.payload ?? {};
      })
      .addCase(fetchProject.rejected, (state, action) => {
        const { statusText } = action.payload as ResponsePayload;

        state.status = "idle";
        state.error = statusText;
      });
  }
});
